import { call, fork, put, take, race } from 'redux-saga/effects';
import { takeEvery, takeLatest } from 'redux-saga';
import browserHistory from 'components/utility/history';
import ConfigurationClient from 'rest/ConfigurationClient';
import { errorAction } from 'components/utility/actions';
import * as restartActions from 'components/widgets/Restart/actions';
import * as actions from './actions';

const configClient = new ConfigurationClient();

export function doListConfigs(env) {
	return configClient.getAll(env);
}

export function doFetchConfig(name) {
	return configClient.get(name);
}

export function doSaveConfig(config) {
	return configClient.update(config);
}

export function redirectToConfiguationListView() {
	browserHistory.push(`${window.$conf.prefix}/project/configuration`);
}

export function *listConfigs(action) {
	try {
		const response = yield call(doListConfigs, action.payload);
		yield put({ type: actions.LIST_CONFIGS_SUCCESS, payload: response.data });
	} catch (error) {
		yield put(errorAction(actions.LIST_CONFIGS_ERROR, error, action));
	}
}

export function *fetchConfig(action) {
	try {
		const response = yield call(doFetchConfig, action.payload);
		yield put({ type: actions.FETCH_CONFIG_SUCCESS, payload: response.data });
	} catch (error) {
		yield put(errorAction(actions.FETCH_CONFIG_ERROR, error, action));
	}
}

export function *saveConfig(action) {
	try {
		yield call(doSaveConfig, action.payload);
		yield put({ type: actions.SAVE_CONFIG_SUCCESS });
	} catch (error) {
		yield put(errorAction(actions.SAVE_CONFIG_ERROR, error, action));
		return;
	}

	// Wait for the restart & redirect
	const [ result ] = yield [
		race({
			success: take(restartActions.AWAIT_RESTART_SUCCESS),
			error: take(restartActions.AWAIT_RESTART_ERROR),
			timeout: take(restartActions.AWAIT_RESTART_TIMEOUT)
		}),
		put(restartActions.awaitRestart())
	];

	if (result && result.success) {
		yield call(redirectToConfiguationListView);
	}
}

export default function *sagas() {
	yield fork(takeLatest, actions.LIST_CONFIGS, listConfigs);
	yield fork(takeLatest, actions.FETCH_CONFIG, fetchConfig);
	yield fork(takeEvery, actions.SAVE_CONFIG, saveConfig);
}
